import React, { useState, useEffect, useRef } from "react";
import { Card, Spinner } from "react-bootstrap";
import Popover from "react-popover";
import Info from "../../../../assets/info.png";
import Availability from "../../../../assets/booked_appt_icon.svg";
import moment from "moment";
// import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopoverContent from "../PopOver/index";
import { ClickAwayListener, Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import Edit from "../../../../assets/edit_icon.svg";
import Done from "../../../../assets/done.svg";
import Delete from "../../../../assets/delete.svg";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import "./cardContainer.scss";
import DelayMarkingButton from "../../../DelayMarking/DelayMarkingButton";
import AffectedAppointmentsPopup from "../../../DelayMarking/AffectedAppointmentsPopup";
import DelayMarkingAlertMsgPopup from "../../../DoctorDashboard/DelayMarkingAlertMsgPopup";
import DelayMarkingModal from "../../../DelayMarking/DelayMarkingModal";
import { useLocation } from "react-router-dom";
import { APIFILTERLIST } from "../../../DashboardAppointmentsView/Constant";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import { GET_DOCTOR_ACCOUNTS_APPOINTMENT } from "../APIHandler/APIConstants";
import { c2cGetApiHandler } from "../../../../Util/c2cApiHandler";

const CardContainer = (props) => {
  const useStyles = makeStyles({
    root: {
      width: "50px",
      height: "24px",
      padding: "0px",
      // marginRight: "-23px",
    },
    switchBase: {
      color: "#818181",
      padding: "3px",
      paddingTop: "2px",
      "&$checked": {
        "& + $track": {
          backgroundColor: "#32D74B",
        },
      },
    },
    thumb: {
      color: "white",
      width: "19px",
      height: "18px",
      marginTop: "1px",
    },
    track: {
      borderRadius: "20px",
      backgroundColor: "#D2D2D4",
      opacity: "1 !important",
      "&:after, &:before": {
        color: "black",
        fontSize: "11px",
        right: "2px",
        position: "absolute",
        top: "6px",
      },
      "&:after": {
        content: "'IN'",
        left: "10px",
        color: "white",
        fontSize: "10px",
      },
      "&:before": {
        content: "'OUT'",
        right: "2px",
        fontSize: "10px",
        // opacity: "0"
      },
    },
    checked: {
      color: "#23bf58 !important",
      transform: "translateX(26px) !important",
    },
  });
  const { doctorData, toggleRoomStatus, updateRoomNumberCallBack } = props;
  const [loader,setLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isOpen, setOpen] = useState(false);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const classes = useStyles();
  const [roomNumber, setRoomNumber] = useState("");
  const [showEditRoom, setShowEditRoom] = useState(false);
  const [roomStatus, setRoomStatus] = useState(false);
  const [doctorAccountApiData,setDoctorAccountApiData] = useState([]);
  const menuOption = [
    {
      label: "Update Profile",
      clickHandler: () => props.handleAdminEditProfileShow(doctorData),
      show:
        userType === "doctor"
          ? doctorData.is_resource === "True"
            ? false
            : true
          : false,
    },
    {
      label: "Share Link",
      clickHandler: () => {
        if (doctorData.is_resource !== "True") {
          props.handleShareLinkClick(doctorData);
        }
      },
      show: true,
    },
  ];

  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const [openDelayMarkingModal, setOpenDelayMarkingModal] = useState(false);
  const [openAffectedAppointments, setOpenAffectedAppointments] =
    useState(false);
  const [scheduleId, setScheduleId] = useState("");
  const [consultationType, setConsultationType] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [showBookedAppointments,setShowBookedAppointments] = useState(false);

  const location = useLocation();
  const selectedDate = new URLSearchParams(location.search).get(
    APIFILTERLIST.STARTDATE
  );

  const prevConsultationType = useRef({});

  //LifeCycle Methods ==>
  useEffect(() => {
    setShowEditRoom(false);
    setRoomNumber(doctorData?.room_name);
    setRoomStatus(doctorData?.room_status === "out" ? false : true);
  }, [doctorData]);

  // Actions ==>

  const handleRoomStatus = (event) => {
    setRoomStatus(event.target.checked);
    toggleRoomStatus(doctorData.doctor_id, event.target.checked ? "in" : "out");
    updateRoomDetails(event.target.checked);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditNumber = () => {
    setShowEditRoom(false);
    updateRoomDetails(roomStatus);
  };
  const handleRoomNumberChange = (e) => {
    let blockSpecialRegex = /[~`'"*!@#$%^&()_={}[\]:;,.<>+?-]/;
    if (!blockSpecialRegex.test(e.target.value)) {
      setRoomNumber(e.target.value);
    }
  };

  // Actions ===>

  const handleDelayMarkingBtn = () => {
    setSelectedConsultation(null);
    setOpenDelayMarkingModal(true);
  };

  const handleConsultationDropDown = (option) => {
    if (prevConsultationType.current?.value !== option?.value) {
      localStorage.removeItem("delayMarkingSlotsList");
    }
    setSelectedConsultation(option);
  };

  const handleReviewChanges = (id) => {
    setScheduleId(id);
    setConsultationType(selectedConsultation?.label);
    setOpenDelayMarkingModal(false);
    setOpenAffectedAppointments(true);
  };

  const handleClosePopup = () => {
    localStorage.removeItem("delayMarkingSlotsList");
    setOpenAffectedAppointments(false);
  };

  const handleOpenPrevPopop = () => {
    setOpenAffectedAppointments(false);
    setOpenDelayMarkingModal(true);
  };

  const handleMarkDelaySuccess = () => {
    localStorage.removeItem("delayMarkingSlotsList");
    handleOpenPrevPopop();
    setOpenAlert(true);
    setAlertMsg(
      <span>
        Mark Delay is Successful for <b>{doctorData?.dr_name}</b>
      </span>
    );
    setTimeout(() => {
      setOpenAlert(false);
    }, 2000);
  };

  const handleClose = () => {
    localStorage.removeItem("delayMarkingSlotsList");
    setOpenDelayMarkingModal(false);
  };

  // <===

  //Helper ==>

  const handleAvailabilitySlots = () =>{
    if(moment().format('ll') === moment(selectedDate).format('ll')){
      return "Availability for today"
    }else{
      return `Availability for ${moment(selectedDate).format('MMM DD, YYYY')}`
    }    
  }

  const handleBookedAppointments = () =>{
    setLoader(true);
    let openBookedAppointmentsPopup = !showBookedAppointments;
    setShowBookedAppointments(openBookedAppointmentsPopup);
    if(openBookedAppointmentsPopup){
      let payload = {
        doctor_id : doctorData.doctor_id,
        clinic_id : clinicId,
        selected_date:selectedDate
      };

      c2cGetApiHandler(GET_DOCTOR_ACCOUNTS_APPOINTMENT, payload)
      .then(([res,err]) => {
        if(!err) {
          if(res?.data?.statusCode === 200){
            setDoctorAccountApiData(res.data.data)
            setLoader(false);
          }else{
            setLoader(false);
          }
          
        }else{
          C2CConsole.log("Error Occured");
          setLoader(false);
        }
      });
    }else{
      setLoader(false);
    }
  }

  const updateRoomDetails = (value) => {
    let data = {
      doctor_id: doctorData?.doctor_id,
      room_status: value ? "in" : "out",
      room_name: roomNumber,
    };

    if (clinicId && clinicId !== undefined && clinicId !== null) {
      data["clinic_id"] = clinicId;
    }
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/update-room-status",
      headers: {
        Authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
      },
      data: data,
    })
      .then((response) => {
        if (response.data.statusCode === 200) {
          updateRoomNumberCallBack(data);
        } else if (response.data.statusCode === 504) {
        } else {
        }
      })
      .catch((err) => C2CConsole.log(err));
  };
  // <==

  // Create UI ==>

  const popoverContents = () =>{
    let totalAppointments = doctorAccountApiData?.total_appointments?doctorAccountApiData?.total_appointments:0;
    let appointmentText;
    if(totalAppointments === 1 ){
      appointmentText = "Appointment Booked";
    }else{
      appointmentText = "Appointments Booked"
    }

    return (
      <div className="loader-and-appointment-text-box-wrapper">
          {loader ? (
              <div className="spinner-loader-wrapper-box">
                <Spinner className= "spinner-loader" animation="border"/>
              </div>
          ) : (
              <div className="total-appointment-booked-text">
                  {doctorAccountApiData.total_appointments} {appointmentText}
              </div>
          )}
      </div>
  );
  }
  
  const cardHeader = () => {
    return (
      <Card.Header className="pb-0">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12 d-flex justify-content-between pr-1">
            <div className="d-flex">
              <div className="profile-container no-image">
                {doctorData?.doctor_profile_picture_url?.length !== 0 ? (
                  <img
                    src={
                      doctorData?.doctor_profile_picture_url
                        ? doctorData?.doctor_profile_picture_url[0]
                        : ""
                    }
                    roundedCircle
                    className="profile-container"
                    alt="profile"
                  />
                ) : (
                  doctorData?.doctor_first_name?.charAt(0)
                )}
              </div>
              <div
                className="text-left px-2"
                style={{
                  marginTop:
                    doctorData.is_resource === "True" &&
                    !doctorData.doctor_specialization
                      ? "10px"
                      : "0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    whiteSpace: "nowrap",
                    width: "150px",
                  }}
                >
                  <p className="doctor_name">{doctorData.dr_name}</p>
                </div>

                <p
                  className="doctor_specialization"
                  style={{ display: "flex" }}
                >
                  {doctorData.is_resource === "False"
                    ? doctorData?.doctor_specialization
                      ? doctorData.doctor_specialization
                      : "Specialization"
                    : doctorData.is_resource === "True"
                    ? doctorData?.doctor_specialization
                    : ""}

                  {doctorData.is_resource == "False" && (
                    <Popover
                      isOpen={isOpen}
                      preferPlace={window.innerWidth > 768 ? `left` : "below"}
                      place={null}
                      body={<PopoverContent doctorData={doctorData} />}
                    >
                      <img
                        src={Info}
                        alt=""
                        className="ml-2 mt-1"
                        style={{ height: "17px", cursor: "pointer" }}
                        onMouseOver={() => {
                          setOpen(true);
                        }}
                        onMouseOut={() => {
                          setOpen(false);
                        }}
                      />
                    </Popover>
                  )}
                </p>
              </div>
            </div>

            <div className="switch-menu-wrapper">
              <Switch
                classes={{
                  root: classes.root,
                  switchBase: classes.switchBase,
                  thumb: classes.thumb,
                  track: classes.track,
                  checked: classes.checked,
                }}
                // defaultChecked={checkedValue}
                checked={doctorData.room_status === "in"}
                // checked={isChecked}
                onChange={handleRoomStatus}
                // name="checkedA"
                inputProps={{ "aria-label": "secondary checkbox" }}
                // style={{ marginRight: "2px" }}
              />
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                id="long-button"
                aria-haspopup="true"
                onClick={handleMenuClick}
                style={{ padding: "0px", marginBottom: "21px" }}
              >
                <MoreVertIcon />
              </IconButton>

              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted={false}
                open={open}
                getContentAnchorEl={null}
                onClose={handleMenuClose}
                PaperProps={{
                  style: {
                    transform: "translateX(-10px) translateY(25px)",
                  },
                }}
              >
                {menuOption?.map(
                  (opt, id) =>
                    opt?.show && (
                      <MenuItem onClick={handleMenuClose} key={id}>
                        <div
                          onClick={opt.clickHandler}
                          style={{
                            font: "normal normal normal 12px/14px Rubik",
                            color: "#1b2027",
                            width: "100%",
                          }}
                        >
                          {opt.label}
                        </div>
                      </MenuItem>
                    )
                )}
              </Menu>
            </div>
          </div>
        </div>
      </Card.Header>
    );
  };

  const cardBody = () => {
    return (
      <Card.Body>
        <div>
          <div className="doctor_availablity d-flex justify-content-between align-items-center px-3 py-2">
            <div className={doctorData?.on_vacation ? "accounts-on-vacation-text-and-icon":null}> 
              <div className={doctorData?.on_vacation ? "accounts-on-vacation-icon-box":null}>
                <div className="accounts-availability-text-and-icon">
                  { doctorData?.on_vacation ? null:(<p className="label">{handleAvailabilitySlots()}</p>)}
                  <Popover
                  isOpen={showBookedAppointments}
                  preferPlace="below"
                  place="below"
                  body={popoverContents()} 
                  >
                    <ClickAwayListener onClickAway={()=>setShowBookedAppointments(false)}>
                      <img 
                        src={Availability} 
                        alt="Availability" 
                        className="accounts-availability-icon" 
                        onClick={handleBookedAppointments}
                        style={{cursor:"pointer"}}
                        
                      />
                    </ClickAwayListener>
                  </Popover>
                </div>
              </div>
      
              {doctorData?.on_vacation ? (
                <p className="slot-not-avail slot-on-vacation">On Vacation</p>
              ) : (
                displayAvailableSlot()
              )}
            </div>
            <div>
              {doctorData?.mark_delay_on_selected_date &&
                moment(selectedDate).isSameOrAfter(
                  moment().format("YYYY-MM-DD")
                ) &&
                getAvailablityWithDelayBtn()}
            </div>
          </div>
          {!showEditRoom ? (
            <span className="room-name pl-3 ">
              Room No:
              {doctorData.room_name}
              <img
                src={Edit}
                alt="Edit Receipt"
                className="ml-2"
                onClick={() => {
                  setShowEditRoom(true);
                }}
              />
            </span>
          ) : (
            <div className="">
              <input
                type="text"
                className="room-number pl-2"
                value={roomNumber}
                maxLength="24"
                onChange={handleRoomNumberChange}
              />
              <img
                src={Delete}
                alt="delete"
                className="action-button-delete pr-2"
                onClick={() => {
                  setShowEditRoom(false);
                }}
              />
              <img
                src={Done}
                alt="done"
                className="action-button-done pr-2 pl-2"
                onClick={handleEditNumber}
              />
            </div>
          )}
          {doctorData.is_resource == "True" ? (
            <div className="pl-3 pt-2 pb-3 pr-2 d-flex justify-content-center">
              <button
                className="btn mr-2"
                style={{ fontSize: "12px", height: "40px", width: "300px" }}
                onClick={() => {
                  props.handleInClinicClick(doctorData);
                }}
              >
                Book Procedure
              </button>
            </div>
          ) : (
            // If the doctor's role is not the specified resource roles
            <div className="pl-3 pt-2 pb-3 pr-2 d-flex justify-content-between">
              <button
                className="btn mr-2"
                style={{ fontSize: "12px", height: "40px" }}
                onClick={() => props.handleOnlineClick(doctorData)}
              >
                Book Online
              </button>
              <button
                className="btn ml-2"
                style={{ fontSize: "12px", height: "40px" }}
                onClick={() => props.handleInClinicClick(doctorData)}
              >
                Book In-Clinic
              </button>
            </div>
          )}
        </div>
      </Card.Body>
    );
  };

  const getAccountCard = () => {
    return (
      <Card>
        {cardHeader()}
        {cardBody()}
      </Card>
    );
  };

  const displayAvailableSlot = () => {
    if (doctorData?.start_time !== "" && doctorData?.end_time !== "") {
      return (
        <div className="d-flex align-items-center">
          <p className="slot-avail">
            {moment(doctorData?.start_time, "hh:mm:ssZ").format("hh:mm A")} -{" "}
            {moment(doctorData?.end_time, "hh:mm:ssZ").format("hh:mm A")}
          </p>
          {doctorData?.is_delay_marked_on_selected_date && (
            <Brightness1Icon
              className="mx-1"
              style={{ width: "6px", color: "#F83636", paddingBottom: "2px" }}
            />
          )}
        </div>
      );
    } else {
      return <p className="slot-not-avail">No slots available</p>;
    }
  };

  const getAvailablityWithDelayBtn = () => {
    return (
      <DelayMarkingButton
        isCardBtn={true}
        handleClick={handleDelayMarkingBtn}
      />
    );
  };

  // render UI <==

  return (
    <div className="dashboard-accounts-card">
      {getAccountCard()}
      {openDelayMarkingModal && (
        <DelayMarkingModal
          open={openDelayMarkingModal}
          selectedConsultation={selectedConsultation}
          handleClose={handleClose}
          handleReviewChanges={handleReviewChanges}
          handleConsultationDropDown={handleConsultationDropDown}
          doctorName={doctorData?.dr_name}
          doctorId={doctorData?.doctor_id}
        />
      )}
      {openAffectedAppointments && (
        <AffectedAppointmentsPopup
          openPopup={openAffectedAppointments}
          scheduleId={scheduleId}
          doctorName={doctorData?.dr_name}
          consultationType={consultationType}
          handleClosePopup={handleClosePopup}
          handleOpenPrevPopop={handleOpenPrevPopop}
          handleMarkDelaySuccess={handleMarkDelaySuccess}
        />
      )}
      {openAlert && <DelayMarkingAlertMsgPopup alertMsg={alertMsg} />}
    </div>
  );
};

export default CardContainer;
